export default __webpack_public_path__ + "static/media/knife-mask-21.5720436c.svg";